<template>
  <div
    class="selectedSubCategories"
    :class="[{ 'selectedSubCategories--disableWhiteBackground': data.disableWhiteBackground }]"
  >
    <div class="container">
      <SectionContainer
        :title="data.title"
        :small-title="data.smallTitle"
        :disable-white-background="data.disableWhiteBackground"
        :link="
          categoryObject
            ? {
                smallTitle: data.smallTitle ? data.smallTitle : '',
                title: 'ZOBACZ WSZYSTKIE',
                path: localePath({ name: 'category-slug', params: { slug: categoryObject.slug } }),
              }
            : undefined
        "
      >
        <div class="selectedSubCategories__content">
          <CategoriesWithListGrid :items="categories" />
        </div>
      </SectionContainer>
    </div>
  </div>
</template>

<script>
import CategoriesWithListGrid from '@/components/CategoriesWithListGrid.vue';
import SectionContainer from '@/components/SectionContainer.vue';

export default {
  name: 'SelectedSubCategories',
  components: { SectionContainer, CategoriesWithListGrid },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    categoryObject: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.selectedSubCategories {
  $root: &;
  padding-top: 1rem;
  margin-bottom: 1.6rem;

  &__content {
    padding: 2rem;
  }

  &--disableWhiteBackground {
    #{$root}__content {
      padding: 2rem 0;
    }
  }
}
</style>
